/* Cesta kríža – theme.js (bez závislostí) */
(() => {
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const T = window.theme || {};

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const format = T.moneyFormat || '{{amount_with_comma_separator}} €';
    const value = (cents / 100);
    const withSep = (n, dec, thou) => {
      const [i, d] = n.toFixed(2).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + dec + d;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return withSep(value, '.', ',');
        case 'amount_no_decimals': return Math.round(value).toString();
        case 'amount_with_comma_separator': return withSep(value, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        case 'amount_with_space_separator': return withSep(value, ',', ' ');
        default: return withSep(value, ',', ' ');
      }
    });
  }

  /* ---------- Announcement rotation ---------- */
  const annItems = $$('.announcement__item');
  if (annItems.length > 1) {
    let i = 0;
    setInterval(() => {
      annItems[i].classList.remove('is-active');
      i = (i + 1) % annItems.length;
      annItems[i].classList.add('is-active');
    }, 4500);
  }

  /* ---------- Mobile menu ---------- */
  const menuToggle = $('[data-menu-toggle]');
  const mobileMenu = $('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = mobileMenu.hasAttribute('hidden');
      mobileMenu.toggleAttribute('hidden', !open);
      menuToggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- Cart drawer ---------- */
  const drawerSectionId = 'cart-drawer';
  const getDrawer = () => $('[data-cart-drawer]');

  function openDrawer() {
    const d = getDrawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    const d = getDrawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  async function refreshCart(open = false) {
    try {
      const res = await fetch(`${T.routes.root_url.replace(/\/$/, '')}/?sections=${drawerSectionId}`);
      const data = await res.json();
      const html = new DOMParser().parseFromString(data[drawerSectionId], 'text/html');
      const fresh = html.querySelector('[data-cart-drawer]');
      const current = getDrawer();
      if (fresh && current) {
        const wasOpen = current.classList.contains('is-open');
        current.replaceWith(fresh);
        if (wasOpen || open) openDrawer();
      }
      const cart = await (await fetch(`${T.routes.cart_url}.js`)).json();
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
      });
    } catch (e) {
      window.location.href = T.routes.cart_url;
    }
  }

  document.addEventListener('click', async (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && getDrawer()) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    const qtyBtn = e.target.closest('[data-qty-change]');
    const removeBtn = e.target.closest('[data-remove]');
    if (qtyBtn || removeBtn) {
      const line = (qtyBtn || removeBtn).closest('[data-line]');
      if (!line) return;
      const current = parseInt(line.querySelector('.qty span')?.textContent || '1', 10);
      const quantity = removeBtn ? 0 : Math.max(0, current + parseInt(qtyBtn.dataset.qtyChange, 10));
      line.style.opacity = '.5';
      await fetch(`${T.routes.cart_change_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line.dataset.line, 10), quantity })
      });
      refreshCart();
      return;
    }

    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      quick.disabled = true;
      await fetch(`${T.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(quick.dataset.quickAdd, 10), quantity: 1 }] })
      });
      refreshCart(true);
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); $$('.modal').forEach((m) => m.setAttribute('hidden', '')); } });

  /* ---------- Product form (AJAX) ---------- */
  $$('form.product-form').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      if (!getDrawer()) return; // fallback: normálny submit
      e.preventDefault();
      const btn = form.querySelector('[data-add-button]');
      const err = form.querySelector('[data-form-error]');
      const label = btn.textContent;
      btn.disabled = true;
      btn.textContent = T.strings.adding;
      err && err.setAttribute('hidden', '');
      try {
        const bundleItems = getBundleItems(form);
        if (bundleItems === false) throw new Error('Vyberte prosím veľkosť pri každom kuse.');
        const res = bundleItems
          ? await fetch(`${T.routes.cart_add_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: bundleItems }) })
          : await fetch(`${T.routes.cart_add_url}.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const data = await res.json();
        if (data.status) throw new Error(data.description || data.message);
        const handle = form.closest('[data-product-handle]')?.dataset.productHandle;
        if (!(await maybeShowUpsell(handle))) await refreshCart(true);
      } catch (ex) {
        if (err) { err.textContent = ex.message; err.removeAttribute('hidden'); }
      } finally {
        btn.disabled = false;
        btn.textContent = label;
      }
    });
  });

  /* ---------- Upsell popup (2. kus -X %) ---------- */
  async function maybeShowUpsell(handle) {
    const pop = $('[data-upsell]');
    if (!pop) return false;
    try { if (sessionStorage.getItem('ck-upsell-shown')) return false; } catch (e) {}
    const cart = await (await fetch(`${T.routes.cart_url}.js`)).json();
    if (cart.item_count !== 1) return false;
    const design = (handle || '').split('-').slice(1).join('-');
    const cards = $$('[data-upsell-card]', pop);
    const list = $('.upsell__list', pop);
    cards.forEach((c) => {
      const same = c.dataset.handle === handle;
      const twin = !same && design && c.dataset.handle.split('-').slice(1).join('-') === design;
      c.hidden = same;
      c.classList.toggle('is-featured', twin);
      if (twin) list.prepend(c);
    });
    cards.filter((c) => !c.hidden && !c.classList.contains('is-featured')).slice(3).forEach((c) => { c.hidden = true; });
    pop.hidden = false;
    document.body.style.overflow = 'hidden';
    try { sessionStorage.setItem('ck-upsell-shown', '1'); } catch (e) {}
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.classList.remove('is-empty'); });
    return true;
  }
  function closeUpsell() {
    const pop = $('[data-upsell]');
    if (!pop || pop.hidden) return;
    pop.hidden = true;
    document.body.style.overflow = '';
    refreshCart(true);
  }
  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-upsell-close]')) { closeUpsell(); return; }
    const add = e.target.closest('[data-upsell-add]');
    if (!add) return;
    const card = add.closest('[data-upsell-card]');
    const id = card.querySelector('[data-upsell-variant]')?.value;
    const err = $('[data-upsell-error]');
    if (!id) { err.hidden = false; card.querySelector('select')?.focus(); return; }
    err.hidden = true;
    add.disabled = true; add.textContent = '…';
    await fetch(`${T.routes.cart_add_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }) });
    add.textContent = '✓';
    closeUpsell();
  });

  /* ---------- Balík a zľava (1 / +1 / +2 kusy) ---------- */
  function bundleState(bundle) {
    const tier = parseInt(bundle.querySelector('input[type=radio]:checked')?.value || '1', 10);
    return { tier, label: bundle.querySelector(`[data-tier="${tier}"]`) };
  }
  function getBundleItems(form) {
    const section = form.closest('[data-product-section]');
    const bundle = section && $('[data-bundle]', section);
    if (!bundle) return null;
    const { tier, label } = bundleState(bundle);
    if (tier <= 1) return null;
    const main = parseInt($('[data-variant-id]', section).value, 10);
    const items = [{ id: main, quantity: 1 }];
    let ok = true;
    $$('[data-slot]', label).forEach((slot) => {
      const v = slot.querySelector('[data-slot-size]').value;
      if (!v) { ok = false; slot.classList.add('is-error'); } else { slot.classList.remove('is-error'); items.push({ id: parseInt(v, 10), quantity: 1, properties: { _ck_addon: '1' } }); }
    });
    const err = $('[data-bundle-error]', bundle);
    if (err) err.hidden = ok;
    return ok ? items : false;
  }
  $$('[data-bundle]').forEach((bundle) => {
    const section = bundle.closest('[data-product-section]');
    const products = JSON.parse($('[data-bundle-products]', bundle).textContent);
    const byHandle = Object.fromEntries(products.map((p) => [p.handle, p]));
    const mainHandle = $('[data-product-handle]', section)?.dataset.productHandle || '';
    const design = (h) => h.split('-').slice(1).join('-');
    const pct = { 2: parseFloat(bundle.dataset.pct2) / 100, 3: parseFloat(bundle.dataset.pct3) / 100 };
    const variantsMain = JSON.parse($('[data-variants]', section)?.textContent || '[]');
    const mainPrice = () => {
      const id = parseInt($('[data-variant-id]', section).value, 10);
      const v = variantsMain.find((x) => x.id === id);
      return v ? v.price : (variantsMain[0]?.price || 0);
    };
    function fillSizes(slot, keep) {
      const p = byHandle[slot.querySelector('[data-slot-product]').value];
      const sel = slot.querySelector('[data-slot-size]');
      const prev = keep ? sel.selectedOptions[0]?.textContent : null;
      sel.innerHTML = '<option value="">Veľkosť</option>' + p.variants.map((v) => `<option value="${v.id}" ${v.available ? '' : 'disabled'}>${v.title}</option>`).join('');
      if (prev) { const o = [...sel.options].find((x) => x.textContent === prev); if (o && !o.disabled) sel.value = o.value; }
    }
    function showSlotDesign(slot) {
      const handle = slot.querySelector('[data-slot-product]').value;
      const p = byHandle[handle];
      const img = slot.querySelector('[data-slot-img]');
      if (img && p) { img.src = p.image || ''; img.alt = p.title; img.hidden = !p.image; }
      $$('[data-pick]', slot).forEach((b) => b.classList.toggle('is-active', b.dataset.pick === handle));
    }
    function slotPrice(slot) {
      const p = byHandle[slot.querySelector('[data-slot-product]').value];
      const vid = parseInt(slot.querySelector('[data-slot-size]').value, 10);
      const v = p.variants.find((x) => x.id === vid) || p.variants[0];
      return v.price;
    }
    function render() {
      const { tier } = bundleState(bundle);
      $$('[data-tier]', bundle).forEach((l) => l.classList.toggle('is-selected', parseInt(l.dataset.tier, 10) === tier));
      [1, 2, 3].forEach((t) => {
        const label = $(`[data-tier="${t}"]`, bundle);
        const addons = $$('[data-slot]', label).map(slotPrice);
        const full = mainPrice() + addons.reduce((a, b) => a + b, 0);
        const disc = t > 1 ? addons.reduce((a, b) => a + Math.floor(b * pct[t]), 0) : 0; // zľava len na pridané kusy, po kusoch zaokrúhlená nadol ako v Shopify (1049,7 → 1049 centov)
        const total = Math.round(full - disc);
        const priceEl = $(`[data-tier-price="${t}"]`, bundle);
        priceEl.innerHTML = `<strong>${formatMoney(total)}</strong>` + (disc ? `<s>${formatMoney(full)}</s>` : '');
        const save = $(`[data-tier-save="${t}"]`, bundle);
        if (save) save.textContent = disc ? `Ušetríte ${formatMoney(Math.round(disc))}` : '';
      });
    }
    // predvoľby: 2. kus = rovnaký dizajn v druhom type, 3. kus = iný dizajn
    const twin = products.find((p) => p.handle !== mainHandle && design(p.handle) === design(mainHandle));
    const others = products.filter((p) => p.handle !== mainHandle && p !== twin);
    $$('[data-tier]', bundle).forEach((label) => {
      $$('[data-slot]', label).forEach((slot, i) => {
        const pick = i === 0 ? (twin || others[0]) : (others[i - 1] || others[0]);
        if (pick) slot.querySelector('[data-slot-product]').value = pick.handle;
        fillSizes(slot, false);
        showSlotDesign(slot);
      });
    });
    bundle.addEventListener('click', (e) => {
      const pick = e.target.closest('[data-pick]');
      if (!pick) return;
      e.preventDefault(); // klik je vnútri <label> – nemeniť stupeň
      const slot = pick.closest('[data-slot]');
      slot.querySelector('[data-slot-product]').value = pick.dataset.pick;
      fillSizes(slot, true);
      showSlotDesign(slot);
      slot.classList.remove('is-error');
      render();
    });
    bundle.addEventListener('change', (e) => {
      const slot = e.target.closest('[data-slot]');
      if (e.target.matches('[data-slot-product]')) { fillSizes(slot, true); showSlotDesign(slot); }
      if (slot) slot.classList.remove('is-error');
      render();
    });
    section.addEventListener('change', (e) => { if (e.target.closest('[data-variant-picker]')) setTimeout(render, 0); });
    render();
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('[data-qty-input]');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
  });

  /* ---------- Gallery ---------- */
  function showMedia(section, mediaId) {
    if (!mediaId) return;
    $$('.product__slide', section).forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId === String(mediaId)));
    $$('.product__thumb', section).forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(mediaId)));
  }
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    showMedia(thumb.closest('[data-product-section]'), thumb.dataset.thumb);
  });

  /* ---------- Variant picker ---------- */
  $$('[data-variant-picker]').forEach((picker) => {
    const section = picker.closest('[data-product-section]');
    const variants = JSON.parse(picker.querySelector('[data-variants]').textContent);
    const idInput = $('[data-variant-id]', section);
    const addBtn = $('[data-add-button]', section);
    const stickyBtn = $('[data-sticky-button]', section);
    const stickyPrice = $('[data-sticky-price]', section);
    const priceWrap = $('[data-product-price] [data-price]', section);

    const selected = () => $$('fieldset', picker).filter((fs) => fs.querySelector('input')).map((fs) => fs.querySelector('input:checked')?.value);

    function markAvailability() {
      const sel = selected();
      $$('input[data-option-index]', picker).forEach((input) => {
        const idx = parseInt(input.dataset.optionIndex, 10);
        const test = sel.slice(); test[idx] = input.value;
        const ok = variants.some((v) => v.available && v.options.every((o, i) => o === test[i]));
        input.classList.toggle('is-unavailable', !ok);
      });
    }

    function update() {
      const sel = selected();
      $$('[data-selected-label]', picker).forEach((el, i) => { el.textContent = sel[i]; });
      const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
      markAvailability();
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = T.strings.unavailable;
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      if (stickyBtn) { stickyBtn.disabled = !v.available; }
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (priceWrap) {
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        priceWrap.classList.toggle('price--sale', !!sale);
        priceWrap.innerHTML = `<span class="price__current">${formatMoney(v.price)}</span>` +
          (sale ? `<s class="price__compare">${formatMoney(v.compare_at_price)}</s><span class="badge badge--sale">−${Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price)} %</span>` : '');
      }
      if (v.featured_media) showMedia(section, v.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }

    picker.addEventListener('change', update);
    markAvailability();
  });

  /* ---------- Sticky add to cart ---------- */
  const sticky = $('[data-sticky-atc]');
  const buy = $('.product__buy');
  if (sticky && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(buy);
  }

  /* ---------- Modal ---------- */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-modal-open]');
    if (opener) { document.getElementById(opener.dataset.modalOpen)?.removeAttribute('hidden'); return; }
    if (e.target.closest('[data-modal-close]')) e.target.closest('.modal')?.setAttribute('hidden', '');
  });

  /* ---------- Collection sort & filters ---------- */
  const sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
  const filterForm = $('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', () => {
      const params = new URLSearchParams(new FormData(filterForm));
      window.location.search = params.toString();
    });
  }

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (e) { /* ticho */ }
  });

  /* ---------- Výber dopravy a výdajného miesta v košíku ---------- */
  const DP = { state: null };
  const DP_SCRIPTS = {
    packeta: 'https://widget.packeta.com/v6/www/js/library.js',
    posta: 'https://static.posta.sk/pickup-widget/v1/lib.js',
    gls: 'https://map.gls-slovakia.com/widget/gls-dpm.js'
  };
  const dpLoaded = {};
  function dpLoad(code) {
    if (!dpLoaded[code]) {
      dpLoaded[code] = new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = DP_SCRIPTS[code];
        if (code === 'gls') s.type = 'module';
        s.onload = resolve;
        s.onerror = () => { dpLoaded[code] = null; reject(new Error('Mapu sa nepodarilo načítať. Skúste to prosím znova.')); };
        document.head.appendChild(s);
      });
    }
    return dpLoaded[code];
  }

  async function dpGetState() {
    if (DP.state) return DP.state;
    try {
      const cart = await (await fetch(`${T.routes.cart_url}.js`)).json();
      const a = cart.attributes || {};
      DP.state = { label: a['Doprava'] || '', point: a['Výdajné miesto'] || '', address: a['Výdajné miesto – adresa'] || '', id: a['Výdajné miesto – ID'] || '' };
    } catch (e) { DP.state = { label: '', point: '', address: '', id: '' }; }
    return DP.state;
  }

  async function dpSave(next) {
    DP.state = next;
    dpRenderAll();
    await fetch(`${T.routes.cart_url}/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: {
        'Doprava': next.label,
        'Výdajné miesto': next.point,
        'Výdajné miesto – adresa': next.address,
        'Výdajné miesto – ID': next.id
      } })
    });
  }

  const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  function dpRenderAll() {
    const st = DP.state;
    if (!st) return;
    $$('[data-delivery-picker]').forEach((picker) => {
      $$('[data-delivery-option]', picker).forEach((opt) => {
        const on = opt.dataset.label === st.label;
        opt.classList.toggle('is-selected', on);
        const radio = opt.querySelector('input[type="radio"]');
        if (radio) radio.checked = on;
        if (opt.dataset.needsPoint !== '1') return;
        const box = opt.querySelector('.delivery-option__point');
        const carrier = opt.dataset.label.split(' – ')[0];
        box.innerHTML = on && st.point
          ? `<p class="delivery-option__chosen">✓ <strong>${esc(st.point)}</strong><br><span>${esc(st.address)}</span></p><button type="button" class="link-underline" data-pick-point>Zmeniť výdajné miesto</button>`
          : `<div class="delivery-option__alert"><p><strong>${esc(carrier)} – výdajné miesto</strong><br>Vyberte si prosím výdajné miesto, kam vám doručíme balík.</p><button type="button" class="button button--outline button--small" data-pick-point>Vybrať výdajné miesto</button></div>`;
      });
      const err = picker.querySelector('[data-delivery-error]');
      if (err && dpValid(st)) err.setAttribute('hidden', '');
    });
  }

  function dpValid(st) {
    if (!st || !st.label) return false;
    const opt = $(`[data-delivery-option][data-label="${CSS.escape(st.label)}"]`);
    if (!opt) return false;
    return opt.dataset.needsPoint !== '1' || !!st.point;
  }

  function dpPick(code) {
    return new Promise(async (resolve, reject) => {
      try { await dpLoad(code); } catch (e) { reject(e); return; }
      if (code === 'packeta') {
        const picker = $('[data-delivery-picker]');
        const key = picker?.dataset.packetaKey;
        const country = picker?.dataset.country || 'sk';
        window.Packeta.Widget.pick(key, (p) => resolve(p ? {
          point: p.name || p.place,
          address: [p.street, [p.zip, p.city].filter(Boolean).join(' ')].filter(Boolean).join(', '),
          id: String(p.id)
        } : null), { country, language: 'sk' });
      } else if (code === 'posta') {
        window.slposta.PickupWidget.open({
          callback: (p) => resolve(p ? {
            point: p.label,
            address: [p.deliveryAddress?.street, [p.deliveryAddress?.zip, p.deliveryAddress?.city].filter(Boolean).join(' ')].filter(Boolean).join(', '),
            id: String(p.id)
          } : null)
        });
      } else if (code === 'gls') {
        await customElements.whenDefined('gls-dpm-dialog');
        let dlg = document.getElementById('gls-dpm-dialog');
        if (!dlg) {
          dlg = document.createElement('gls-dpm-dialog');
          dlg.id = 'gls-dpm-dialog';
          dlg.setAttribute('country', $('[data-delivery-picker]')?.dataset.country || 'sk');
          dlg.setAttribute('language', 'sk');
          document.body.appendChild(dlg);
        }
        const onChange = (e) => {
          dlg.removeEventListener('change', onChange);
          const p = e.detail || {};
          const c = p.contact || {};
          resolve({ point: p.name, address: [c.address, [c.postalCode, c.city].filter(Boolean).join(' ')].filter(Boolean).join(', '), id: String(p.id) });
        };
        dlg.addEventListener('change', onChange);
        dlg.showModal();
      }
    });
  }

  async function dpChoose(opt, openMap) {
    const st = await dpGetState();
    const label = opt.dataset.label;
    if (st.label !== label) await dpSave({ label, point: '', address: '', id: '' });
    if (openMap && opt.dataset.needsPoint === '1') {
      try {
        const res = await dpPick(opt.dataset.deliveryOption);
        if (res && res.point) await dpSave({ label, ...res });
      } catch (ex) {
        const err = opt.closest('[data-delivery-picker]')?.querySelector('[data-delivery-error]');
        if (err) { err.textContent = ex.message; err.removeAttribute('hidden'); }
      }
    }
  }

  document.addEventListener('change', (e) => {
    const radio = e.target.closest('[data-delivery-option] input[type="radio"]');
    if (radio) dpChoose(radio.closest('[data-delivery-option]'), true);
  });
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-pick-point]');
    if (btn) dpChoose(btn.closest('[data-delivery-option]'), true);
  });

  // Bez zvolenej dopravy (a výdajného miesta) nepustíme do pokladne.
  document.addEventListener('submit', async (e) => {
    const submitter = e.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    if (!$('[data-delivery-picker]')) return;
    if (submitter.dataset.dpOk) return;
    e.preventDefault();
    const st = await dpGetState();
    if (dpValid(st)) {
      submitter.dataset.dpOk = '1';
      submitter.click();
      return;
    }
    const msg = !st.label ? 'Vyberte si prosím spôsob dopravy.' : 'Vyberte si prosím výdajné miesto.';
    $$('[data-delivery-error]').forEach((el) => { el.textContent = msg; el.removeAttribute('hidden'); });
    const visible = $$('[data-delivery-picker]').find((p) => p.offsetParent !== null);
    visible?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    $$('.section__head, .product-card, .collection-tile, .image-with-text__content, .verse-banner__content, .testimonial').forEach((el) => {
      el.classList.add('reveal');
      io.observe(el);
    });
  }
})();
